import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Grid } from '../../../lib/grid';
import { Row } from '../../../lib/data-set/row';
import { DataSource } from '../../../lib/data-source/data-source';
import { Deferred, getDeepFromObject } from '../../../lib/helpers';

@Component({
  selector: 'ng2-st-tbody-edit-delete',
  templateUrl: './edit-delete.component.html',
  standalone: false
})
export class TbodyEditDeleteComponent implements OnChanges {
  @Input() public grid: Grid;
  @Input() public row: Row;
  @Input() public source: DataSource;
  @Input() public deleteConfirm: EventEmitter<any>;
  @Input() public editConfirm: EventEmitter<any>;

  @Output() public edit = new EventEmitter<any>();
  @Output() public delete = new EventEmitter<any>();
  @Output() public editRowSelect = new EventEmitter<any>();
  @Output() public revoke = new EventEmitter<any>();
  @Output() public undo = new EventEmitter<any>();
  @Output() public reissue = new EventEmitter<any>();

  public isActionEdit: boolean;
  public isActionDelete: boolean;
  public isActionUndo: boolean;
  public isActionReissue: boolean;
  public isActionRevoked: boolean;
  public editRowButtonContent: string;
  public deleteRowButtonContent: string;
  public revokeRowButtonContent: string;
  public undoRowButtonContent: string;
  public reissueRowButtonContent: string;
  public action: string = '';

  public onEdit(event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.editRowSelect.emit(this.row);

    if (this.grid.getSetting('mode') === 'external') {
      this.edit.emit({
        data: this.row.getNewData(),
        source: this.source,
      });
    } else if (this.grid.getSetting('mode') === 'custom') {
      const deferred = new Deferred();
      deferred.promise
        .then((newData) => {
          this.grid.edit(this.row);
        })
        .catch((err) => {
          // do nothing
        });
      this.edit.emit({
        index: this.row.index,
        data: this.row.getNewData(),
        source: this.source,
        edit: deferred,
      });
      deferred.resolve();
    } else {
      this.grid.edit(this.row);
    }
  }

  public onDelete(event: any) {
    event.preventDefault();
    event.stopPropagation();

    if (this.grid.getSetting('mode') === 'external') {
      this.delete.emit({
        data: this.row.getData(),
        source: this.source,
      });
    } else if (this.grid.getSetting('mode') === 'custom') {
      const deferred = new Deferred();
      deferred.promise
        .then((newData) => {
          this.row.isDeleted = true;
          this.grid.delete(this.row, this.deleteConfirm);
        })
        .catch((err) => {
          this.row.isDeleted = false;
        });
      this.delete.emit({
        index: this.row.index,
        data: this.row.getData(),
        source: this.source,
        delete: deferred,
      });
      deferred.resolve();
    } else {
      this.grid.delete(this.row, this.deleteConfirm);
    }
  }

  public onRevoke(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.row.isRevoked = true;
    this.revoke.emit({
      index: this.row.index,
      data: this.row.getData(),
      source: this.source,
    });
  }

  public onUndo(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.row.isUndo = true;
    this.undo.emit({
      index: this.row.index,
      data: this.row.getData(),
      source: this.source,
    });
  }

  public onReissue(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.row.isReissued = true;
    this.reissue.emit({
      index: this.row.index,
      data: this.row.getData(),
      source: this.source,
    });
  }

  public onChange(event: any) {
    this.row.isDeleted = false;
    const value = (event.target as HTMLSelectElement).value;
    switch (value) {
      case 'edit':
        this.onEdit(event);
        break;
      case 'delete':
        this.onDelete(event);
        break;
      case 'revoke':
        this.onRevoke(event);
        break;
      case 'undo':
        this.onUndo(event);
        break;
      case 'reissue':
        this.onReissue(event);
        break;
      default:
        break;
    }
    event.target.value = '';
  }
  public ngOnChanges() {
    this.isActionEdit = this.grid.getSetting('actions.edit');
    this.isActionDelete = this.grid.getSetting('actions.delete');
    this.isActionUndo = this.grid.getSetting('actions.undo');
    this.isActionReissue = this.grid.getSetting('actions.reissue');
    this.isActionRevoked = this.grid.getSetting('actions.revoked');
    this.editRowButtonContent = this.grid.getSetting('edit.editButtonContent');
    this.deleteRowButtonContent = this.grid.getSetting(
      'delete.deleteButtonContent',
    );
    this.revokeRowButtonContent = this.grid.getSetting(
      'revoke.revokeButtonContent',
    );
    this.undoRowButtonContent = this.grid.getSetting('undo.undoButtonContent');
    this.reissueRowButtonContent = this.grid.getSetting(
      'reissue.reissueButtonContent',
    );
  }
}
